import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reset } from 'redux-form';
import { createPendingSelector } from 'modules/api/selectors';
import { getMarketingExportRequest } from '../actions';
import { getMarketingSources } from '../selectors';
import { MARKETING_DATA_EXPORT_FORM } from '../constants';
import fmDate from 'utils/fmDate';
import { closeModal } from 'components/TP-UI/TPModal/actions';
import ExportMarketingDataModal from '../components/ExportMarketingDataModal';
import PropTypes from 'prop-types';

const ExportMarketingDataModalContainer = ({ modalName, form = MARKETING_DATA_EXPORT_FORM }) => {
  const dispatch = useDispatch();
  const pending = useSelector(createPendingSelector(getMarketingExportRequest));
  const marketingSources = useSelector(getMarketingSources);
  const sourcesOptions = useMemo(
    () =>
      marketingSources.map((source) => ({
        value: source,
        label: source,
      })),
    [marketingSources],
  );

  const initialValues = useMemo(
    () => ({
      dateFrom: fmDate()
        .startOf('month')
        .toISOString(),
      dateTo: fmDate()
        .endOf('day')
        .toISOString(),
      source: marketingSources.length ? marketingSources[0] : '',
    }),
    [marketingSources],
  );

  const handleCancelExport = useCallback(() => {
    dispatch(reset(form));
    dispatch(closeModal(modalName));
  }, [dispatch, modalName, form]);

  const handleSubmit = useCallback(
    (data) => {
      dispatch(getMarketingExportRequest(data));
    },
    [dispatch],
  );

  return (
    <ExportMarketingDataModal
      modalName={modalName}
      form={form}
      loading={pending}
      sources={sourcesOptions}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onCancel={handleCancelExport}
    />
  );
};

ExportMarketingDataModalContainer.propTypes = {
  modalName: PropTypes.string.isRequired,
  form: PropTypes.object,
};

export default ExportMarketingDataModalContainer;
